<template lang="pug">
component.btn.ripple(
  :is="tag"
  :type="type ? type : tag === 'button' ? 'button' : null"
  :uc-button-variant="variant"
  ref="elRef"
  uc-dont-read=""
  v-if="!audioDoc"
)
  span.ripple__wave
  uc-icon.btn-start-icon(:icon="icon" v-if="icon")
  uc-text(:text="text" v-if="text")
  slot
</template>

<script setup lang="ts">
import { computed, ref, inject } from 'vue';
import useTheme from '../stores/useTheme';
import { useEventListener } from '@vueuse/core';

const audioDoc = inject('audioDoc') as boolean;

const theme = useTheme();
const variant = computed(() => theme.value['variant-button']);
const props = defineProps<{
  icon?: string;
  text?: string;
  is?: string;
  type?: string;
}>();
const tag = computed(() => props.is || 'button');

const elRef = ref<HTMLElement | null>(null);

useEventListener(elRef, 'click', () => {
  const el = elRef.value;
  const page = el?.closest('.page');

  if (!el) return;
  if (!page) return;
  if (el?.matches('[disabled]')) return;

  if (el?.classList.contains('unlock')) {
    if (el.matches('.slides .slide:not(:last-child) .unlock')) {
      el.closest('.slides')?.next();
      return;
    } else if (el.matches('.slides .slide:last-child .unlock')) {
      page
        .refreshSections()
        .then(() =>
          el.closest('.scroller')?.scrollOne('next', { force: true })
        );
      return;
    }

    if (el.matches('.carousel .carousel-slide:not(:last-child) .unlock')) {
      el.closest('.carousel')?.next();
      return;
    }

    if (el.closest('.section')) {
      page.unlockAndScroll(el.closest('.section')?.id);
    }
  }
});
</script>
